(function () {
  var PLAY_IN = 0.35;
  var PAUSE_OUT = 0.1;

  document.querySelectorAll("[data-voix-film]").forEach(function (root) {
    var video = root.querySelector("video");
    if (!video) return;

    var playBtn = root.querySelector("[data-voix-play]");
    var soundBtn = root.querySelector("[data-voix-son]");
    var growBtn = root.querySelector("[data-voix-agrandi]");
    var userPaused = false;
    var lastY = window.scrollY;
    var fadeJob = 0;
    var fadeDir = 0;
    var afterOut = null;

    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;

    function soundLabel() {
      if (!soundBtn) return;
      var label = soundBtn.querySelector("[data-label]");
      if (label) label.textContent = video.muted ? "Activer le son" : "Couper le son";
    }

    function sync() {
      root.dataset.voixEtat = video.paused ? "pause" : "lecture";
      if (playBtn) {
        playBtn.setAttribute("aria-pressed", video.paused ? "false" : "true");
        var label = playBtn.querySelector("[data-label]");
        if (label) label.textContent = video.paused ? "Lire" : "Pause";
      }
      if (soundBtn) {
        soundBtn.setAttribute("aria-pressed", video.muted ? "false" : "true");
        soundLabel();
      }
    }

    function play() {
      if (userPaused) return;
      var pending = video.play();
      if (pending && pending.catch) pending.catch(function () { sync(); });
    }

    function easeOut(p) {
      return 1 - Math.pow(1 - p, 2);
    }

    function easeIn(p) {
      return p * p;
    }

    function fadeTo(target, dur, ease, done) {
      var job = ++fadeJob;
      fadeDir = target > 0 ? 1 : -1;
      var from = video.muted ? 0 : video.volume;
      if (target > 0) {
        video.volume = 0;
        video.muted = false;
        video.volume = from;
      }
      sync();
      var t0 = performance.now();
      function step(now) {
        if (fadeJob !== job) return;
        var p = Math.min(1, (now - t0) / dur);
        var eased = ease(p);
        video.volume = from + (target - from) * eased;
        if (p < 1) {
          requestAnimationFrame(step);
          return;
        }
        video.volume = target;
        fadeDir = 0;
        if (target === 0) {
          video.muted = true;
          video.volume = 1;
          var finish = afterOut;
          afterOut = null;
          sync();
          if (finish) finish();
        } else {
          sync();
        }
        if (done) done();
      }
      requestAnimationFrame(step);
    }

    function fadeMute(done) {
      if (video.muted) {
        if (done) done();
        return;
      }
      if (fadeDir === -1) {
        if (done) {
          var prev = afterOut;
          afterOut = function () {
            if (prev) prev();
            done();
          };
        }
        return;
      }
      fadeTo(0, 900, easeOut, done);
    }

    function fadeUnmute() {
      afterOut = null;
      fadeTo(1, 1200, easeIn);
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= PLAY_IN) {
            play();
          } else if (entry.intersectionRatio < PAUSE_OUT) {
            fadeMute(function () {
              if (!video.paused) video.pause();
            });
          }
        });
      }, { threshold: [0, PAUSE_OUT, PLAY_IN, 0.6] });
      io.observe(root);
    } else {
      play();
    }

    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      if (y > lastY + 72) fadeMute();
      lastY = y;
    }, { passive: true });

    if (playBtn) {
      playBtn.addEventListener("click", function () {
        if (video.paused) {
          userPaused = false;
          video.play();
        } else {
          userPaused = true;
          video.pause();
        }
        sync();
      });
    }

    if (soundBtn) {
      soundBtn.addEventListener("click", function () {
        if (video.muted) {
          userPaused = false;
          fadeUnmute();
          video.play();
        } else {
          fadeMute();
        }
        sync();
      });
    }

    if (growBtn) {
      growBtn.addEventListener("click", function () {
        if (document.fullscreenElement) {
          document.exitFullscreen();
          return;
        }
        if (root.requestFullscreen) root.requestFullscreen();
        else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
        else if (root.webkitRequestFullscreen) root.webkitRequestFullscreen();
      });
    }

    video.addEventListener("play", sync);
    video.addEventListener("pause", sync);
    sync();
    play();
  });
})();
